import {
	AvailableUserDTO,
	GetUserByCardNumberRequest,
	GetUserByCardNumberResponse,
	ValidatePasswordForDistributorToolsRequest,
	ValidatePasswordForDistributorToolsResponse,
	ValidatePasswordRequest,
	ValidatePasswordResponse
} from 'core/api';
import { Bus } from 'core/infrastructure';

const process = Bus.buildProcessFn('/bus/');

export async function getUserByCardNumber(cardNumber: string): Promise<AvailableUserDTO> {
	const request = new GetUserByCardNumberRequest({ cardNumber });
	return process(request, (response: GetUserByCardNumberResponse) => response.User);
}

export async function checkUserPassword(userId: number, password: string): Promise<boolean> {
	const request = new ValidatePasswordRequest({ userId, password });
	return process(request, (response: ValidatePasswordResponse) => response.Valid);
}

export async function validateResellerPassword(password: string): Promise<boolean> {
	const request = new ValidatePasswordForDistributorToolsRequest({ password });
	return process(request, (response: ValidatePasswordForDistributorToolsResponse) => response.IsValid);
}